module.exports = __webpack_public_path__ + "img/menu-2.78c0989e.svg";